import reducers from "./reducers";

const eventsReducers = {
  allEvents: reducers.allEventsReducer,
  singleEvent: reducers.singleEventReducer,
  pendingEvents: reducers.pendingEventsReducer,
  eventStatistics: reducers.eventStatisticsReducer,
  offlineTickets: reducers.eventPrintOfflineTickets,
  donwloadTIckets:reducers.downloadOfflineTickets,
  offlineTicketBatches: reducers.offlineTicketsBatches,
};

export { eventsReducers };
